// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4397":"9a5d80ae","8721":"9a5d80ae"}[chunkId] + ".chunk.css";
};